import { render, staticRenderFns } from "./expandBtn.vue?vue&type=template&id=b559bad6&scoped=true"
import script from "./expandBtn.vue?vue&type=script&lang=js"
export * from "./expandBtn.vue?vue&type=script&lang=js"
import style0 from "./expandBtn.vue?vue&type=style&index=0&id=b559bad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b559bad6",
  null
  
)

export default component.exports